class CartItemModal extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('.cart-item-modal__overlay');
    this.content = this.querySelector('.cart-item-modal__content');
    this.closeButton = this.querySelector('.cart-item-modal__close');
    this.continueButton = this.querySelector('.cart-item-modal__continue');
    
    // Éléments pour afficher les informations du produit
    this.imageContainer = this.querySelector('.cart-item-modal__image');
    this.titleElement = this.querySelector('.cart-item-modal__title');
    this.variantElement = this.querySelector('.cart-item-modal__variant');
    this.priceElement = this.querySelector('.cart-item-modal__price');
    
    // Debug pour vérifier que les éléments sont trouvés
    /*console.log('🔍 CartItemModal - Éléments trouvés:', {
      overlay: !!this.overlay,
      content: !!this.content,
      closeButton: !!this.closeButton,
      continueButton: !!this.continueButton
    });*/
    
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Écouter l'événement d'ajout de produit au panier
    document.addEventListener('ajaxProduct:added', (event) => {
      this.showModal(event.detail.product);
    });

    // Fermer la modale - avec debug amélioré
    if (this.closeButton) {
      this.closeButton.addEventListener('click', (e) => {
       // console.log('🔘 Clic sur bouton fermeture détecté');
        e.preventDefault();
        e.stopPropagation();
        this.hideModal();
      });
     // console.log('✅ Event listener ajouté au bouton de fermeture');
    } else {
      console.error('❌ Bouton de fermeture non trouvé !');
    }

    if (this.continueButton) {
      this.continueButton.addEventListener('click', (e) => {
        //console.log('🔘 Clic sur bouton continuer détecté');
        e.preventDefault();
        e.stopPropagation();
        this.hideModal();
      });
     // console.log('✅ Event listener ajouté au bouton continuer');
    } else {
      console.error('❌ Bouton continuer non trouvé !');
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        //console.log('🔘 Clic sur overlay détecté');
        e.preventDefault();
        e.stopPropagation();
        this.hideModal();
      });
     // console.log('✅ Event listener ajouté à l\'overlay');
    } else {
      console.error('❌ Overlay non trouvé !');
    }

    // Fermer avec Escape
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.hidden) {
       // console.log('⌨️ Touche Escape détectée, fermeture de la modale');
        this.hideModal();
      }
    });
   // console.log('✅ Event listener Escape ajouté');
  }

  async showModal(productData) {
   // console.log('🚪 showModal() appelée - début ouverture modale');
    
    // Vérifier que nous avons les données du produit
    if (!productData) {
      console.error('❌ Aucune donnée produit fournie');
      return;
    }

    // Positionner la modale près de l'icône panier
    this.positionModal();

    // Remplir les informations du produit
    await this.populateProductInfo(productData);

    // Afficher la modale
    this.hidden = false;
    this.style.pointerEvents = 'auto';
 //   console.log('👁️ Modale rendue visible');
    
    // Animation d'entrée
    requestAnimationFrame(() => {
      if (this.overlay && this.content) {
        this.overlay.style.opacity = '1';
        this.content.style.opacity = '1';
        this.content.style.transform = 'scale(1)';
       // console.log('🎬 Animation d\'ouverture démarrée');
      }
    });

    // Auto-fermer après 5 secondes
    setTimeout(() => {
      if (!this.hidden) {
        //console.log('⏰ Auto-fermeture après 5 secondes');
        this.hideModal();
      }
    }, 5000);
  }

  hideModal() {
    //console.log('🚪 hideModal() appelée - début fermeture modale');
    
    if (!this.overlay || !this.content) {
      console.error('❌ Éléments overlay ou content manquants pour la fermeture');
      return;
    }

    // Animation de sortie
    this.overlay.style.opacity = '0';
    this.content.style.opacity = '0';
    this.content.style.transform = 'scale(0.95)';
    
   // console.log('🎬 Animation de fermeture démarrée');

    // Masquer complètement après l'animation
    setTimeout(() => {
      this.hidden = true;
      this.style.pointerEvents = 'none';
      //console.log('✅ Modale fermée complètement');
    }, 300);
  }

  positionModal() {
    // La position est maintenant gérée entièrement par CSS
    // Plus besoin de calculs JavaScript complexes !
  }

  async populateProductInfo(productData) {
    try {
      //console.log('🛒 Données produit reçues:', productData);
      
      // Récupérer les informations du produit via l'API
      let productInfo = productData;
      
      // Si on a juste l'ID du variant, récupérer les infos complètes
      if (productData.variant_id && !productData.product_title) {
        try {
          const response = await fetch(`/products.json`);
          const data = await response.json();
          // On devra trouver le produit par variant_id si nécessaire
          // Pour l'instant, on utilise les données disponibles
        } catch (e) {
         // console.log('Impossible de récupérer les infos produit complètes');
        }
      }

      // Image du produit - essayer différentes sources
      let imgSrc = null;
      
     /* console.log('🔍 Recherche d\'image dans:', {
        image: productInfo.image,
        featured_image: productInfo.featured_image,
        variant_image: productInfo.variant_image,
        images: productInfo.images
      }); */
      
      // L'image est directement dans la propriété 'image'
      if (productInfo.image) {
        imgSrc = productInfo.image;
       // console.log('✅ Image trouvée dans .image');
      } else if (productInfo.featured_image) {
        imgSrc = productInfo.featured_image;
       // console.log('✅ Image trouvée dans .featured_image');
      } else if (productInfo.variant_image) {
        imgSrc = productInfo.variant_image;
      //  console.log('✅ Image trouvée dans .variant_image');
      } else if (productInfo.images && productInfo.images.length > 0) {
        imgSrc = productInfo.images[0];
       // console.log('✅ Image trouvée dans .images[0]');
      }

      if (imgSrc && this.imageContainer) {
       // console.log('📸 Image trouvée:', imgSrc);
        
        const img = document.createElement('img');
        
        // S'assurer que l'URL de l'image est correcte
        if (imgSrc.startsWith('//')) {
          imgSrc = 'https:' + imgSrc;
        } else if (imgSrc.startsWith('/')) {
          imgSrc = window.location.origin + imgSrc;
        }
        
        img.src = imgSrc;
        img.alt = productInfo.product_title || productInfo.title || '';
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'cover';
        img.loading = 'lazy';
        
        img.onerror = () => {
         // console.log('❌ Erreur chargement image:', imgSrc);
          if (this.imageContainer) {
            this.imageContainer.innerHTML = '<div style="width:100%;height:100%;background:#f3f4f6;display:flex;align-items:center;justify-content:center;font-size:12px;color:#6b7280;">Image non disponible</div>';
          }
        };
        
        img.onload = () => {
        //  console.log('✅ Image chargée avec succès');
        };
        
        this.imageContainer.innerHTML = '';
        this.imageContainer.appendChild(img);
      } else {
      //  console.log('❌ Aucune image trouvée');
        if (this.imageContainer) {
          this.imageContainer.innerHTML = '<div style="width:100%;height:100%;background:#f3f4f6;display:flex;align-items:center;justify-content:center;font-size:12px;color:#6b7280;">Pas d\'image</div>';
        }
      }

      // Titre du produit
      const title = productInfo.product_title || productInfo.title;
      if (this.titleElement && title) {
        this.titleElement.textContent = title;
      }

      // Variantes (couleur, taille, etc.)
      const variantTitle = productInfo.variant_title || productInfo.variant;
      if (this.variantElement && variantTitle && variantTitle !== 'Default Title') {
        this.variantElement.textContent = variantTitle;
        this.variantElement.style.display = 'block';
      } else if (this.variantElement) {
        this.variantElement.style.display = 'none';
      }

      // Prix - gérer différents formats de prix
      if (this.priceElement && (productInfo.price || productInfo.final_price)) {
        const price = productInfo.final_price || productInfo.price;
        let priceText;
        
        if (typeof price === 'string') {
          priceText = price;
        } else {
          // Prix en centimes, convertir en euros
          const priceInEuros = (price / 100).toFixed(2);
          priceText = `${priceInEuros} €`;
        }
        
        this.priceElement.textContent = priceText;
      }

    } catch (error) {
      console.error('Erreur lors du remplissage des informations produit:', error);
      // Fallback avec des informations de base
      if (this.titleElement) {
        this.titleElement.textContent = 'Produit ajouté au panier';
      }
    }
  }
}

customElements.define('cart-item-modal', CartItemModal);